import { createSignal } from "solid-js"
import type { HomeScrollController } from "./home-scroll-controller"
import type { HomeSessionSearchController } from "./home-session-search-controller"
import { homeSessionSearchKey, type HomeSessionRecord, type HomeSessionsController } from "./home-sessions-controller"
import { HomeSessionsView } from "./home-sessions-view"

export function HomeSessions(props: {
  sessions: HomeSessionsController
  search: HomeSessionSearchController
  scroll: HomeScrollController
}) {
  const [deleteMode, setDeleteMode] = createSignal(false)
  const [selected, setSelected] = createSignal<Set<string>>(new Set())

  function toggleDeleteMode() {
    setDeleteMode((value) => !value)
    setSelected(new Set<string>())
  }

  function toggleSelect(record: HomeSessionRecord) {
    const key = homeSessionSearchKey(record)
    setSelected((prev) => {
      const next = new Set(prev)
      if (next.has(key)) next.delete(key)
      else next.add(key)
      return next
    })
  }

  async function confirmDelete() {
    const keys = selected()
    if (keys.size === 0) return
    const records = props.sessions.data.records().filter((record) => keys.has(homeSessionSearchKey(record)))
    setDeleteMode(false)
    setSelected(new Set<string>())
    await props.sessions.session.bulkDelete(records.map((record) => record.session))
  }

  return (
    <HomeSessionsView
      language={props.sessions.copy.language}
      groups={props.sessions.data.groups}
      showProjectName={props.sessions.session.showProjectName}
      server={props.sessions.session.server}
      canCreateSession={props.sessions.session.canCreate}
      searchValue={props.search.query.value}
      searchPlaceholder={props.search.query.placeholder}
      searchOpen={props.search.query.open}
      searchLoading={props.search.result.loading}
      searchResults={props.search.result.list}
      searchActive={props.search.result.active}
      searchNoResultsLabel={props.search.result.noResultsLabel}
      titleOpacity={props.scroll.header.titleOpacity}
      isOpenTab={props.sessions.tab.isOpen}
      deleteModeActive={deleteMode}
      selectedSessionIds={selected}
      onToggleDeleteMode={toggleDeleteMode}
      onToggleSessionSelect={toggleSelect}
      onConfirmDelete={confirmDelete}
      onCreateSession={props.sessions.session.create}
      onOpenSession={props.sessions.session.open}
      onArchiveSession={props.sessions.session.archive}
      onSetHoverTarget={props.scroll.viewport.setHoverTarget}
      onSetThumbTrack={props.scroll.viewport.setThumbTrack}
      onSetContent={props.scroll.header.setContent}
      onSetHeader={props.scroll.header.setHeader}
      onWheel={props.scroll.viewport.containWheel}
      onSetSearchRoot={props.search.element.setRoot}
      onSetSearchInput={props.search.element.setInput}
      onSetSearchList={props.search.element.setList}
      onSearchFocus={props.search.query.focus}
      onSearchInput={props.search.query.input}
      onSearchClose={props.search.query.close}
      onSearchMove={props.search.result.move}
      onSearchSelectActive={props.search.result.selectActive}
      onSearchHighlight={props.search.result.highlight}
      onSearchSelect={props.search.result.select}
      olderHasMore={props.sessions.data.olderHasMore}
      olderLoading={props.sessions.data.olderLoading}
      loadMoreOlder={props.sessions.data.loadMoreOlder}
    />
  )
}
